module.exports = __webpack_public_path__ + "static/media/WU_STEPS_estimate_active.e2860a66.svg";